import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";

interface ShortcutItem {
  keys: string[];
  description: string;
  group?: string;
}

interface ShortcutsCheatSheetProps {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  items: ShortcutItem[];
}

export function ShortcutsCheatSheet({ open, onOpenChange, items }: ShortcutsCheatSheetProps) {
  const groups = new Map<string, ShortcutItem[]>();
  for (const it of items) {
    const g = it.group || "General";
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g)!.push(it);
  }
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          {Array.from(groups.entries()).map(([group, list]) => (
            <div key={group}>
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">
                {group}
              </p>
              <ul className="space-y-1.5">
                {list.map((it, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 text-sm">
                    <span className="text-foreground/90">{it.description}</span>
                    <span className="flex items-center gap-1">
                      {it.keys.map((k, idx) => (
                        <Badge
                          key={idx}
                          variant="outline"
                          className="font-mono text-[11px] px-1.5 py-0"
                        >
                          {k}
                        </Badge>
                      ))}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
